module.exports = __webpack_public_path__ + "img/zhanwushuju.51df822f.png";